var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect2, _path12, _path13, _path14, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoal5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "#ff3a21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.479,92.112A1.387,1.387,0,0,0,288.952,91v1h1.107V87.114h-2.186v1.215h.729v1.622c0,.594-.258.877-.757.877-.526,0-.756-.392-.756-.945V84.964c0-.551.243-.944.8-.944s.77.324.77.9v.932h1.4v-.811c0-1.351-.5-2.3-2.2-2.3a2.169,2.169,0,0,0-2.308,2.472v4.431c0,1.418.606,2.472,1.929,2.472",
    transform: "translate(-253.567 -73.473)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338.522,91.573h-2.133V88.79h1.527V87.547h-1.527V84.928h2.133V83.67H334.85v9.16h3.672Z",
    transform: "translate(-297.345 -74.299)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M377.506,87.075l1.808,5.755h1.351V83.67h-1.281v5.255l-1.662-5.255H376.21v9.16h1.3Z",
    transform: "translate(-334.072 -74.299)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M429.607,90.335V86.094c0-1.418-.58-2.464-2.228-2.464H425v9.16h2.375c1.648,0,2.228-1.054,2.228-2.464m-3.063,1.2V84.891h.649a.8.8,0,0,1,.876.918v4.8c0,.553-.242.932-.876.932Z",
    transform: "translate(-377.398 -74.263)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M478.862,91.573H476.73V88.79h1.526V87.547H476.73V84.928h2.131V83.67H475.19v9.16h3.672Z",
    transform: "translate(-421.966 -74.299)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M518,88.618l1.437,4.2h1.621l-1.466-4.161c.877-.2,1.232-.784,1.232-1.77V85.714c0-1.284-.567-2.054-2.119-2.054h-2.24v9.16H518Zm0-3.7h.511c.527,0,.756.242.756.741v1.344a.664.664,0,0,1-.756.757H518Z",
    transform: "translate(-458.614 -74.29)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M289.222,211.462h-2.133V208.68h1.526v-1.242h-1.526v-2.621h2.133V203.56H285.55v9.159h3.672Z",
    transform: "translate(-253.567 -180.76)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M328.545,211.856v.623l2.9.54v-1.148l-1.134-.217a2.2,2.2,0,0,0,1.134-2.161v-4.431a2.332,2.332,0,1,0-4.656,0v4.431a2.105,2.105,0,0,0,1.755,2.363m-.217-7.036c0-.553.243-.946.784-.946s.8.393.8.946v5c0,.54-.242.944-.8.944s-.784-.4-.784-.944Z",
    transform: "translate(-290.188 -179.899)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M377.29,203.56v6.93a2.064,2.064,0,0,0,2.3,2.336c1.568,0,2.174-.918,2.174-2.336v-6.93h-1.417v7.078c0,.541-.216.905-.757.905s-.756-.364-.756-.905V203.56Z",
    transform: "translate(-335.031 -180.76)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M425.723,211.079h1.638l.283,1.68h1.579l-1.742-9.159h-1.759L424,212.754h1.456Zm.809-4.9h.016l.606,3.674h-1.232Z",
    transform: "translate(-376.51 -180.796)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M477.36,203.56v9.159h3.375v-1.256H478.9v-7.9Z",
    transform: "translate(-423.893 -180.76)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.54,
    height: 9.159,
    transform: "translate(57.666 22.8)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M538.9,212.728v-7.9h1.268V203.57H536.08v1.256h1.268v7.9Z",
    transform: "translate(-476.036 -180.769)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M579.494,212.728h1.54v-3.484l1.7-5.673h-1.47l-.932,3.47h-.013l-.931-3.47H577.78l1.714,5.673Z",
    transform: "translate(-513.066 -180.769)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.823,90.862a3.423,3.423,0,0,0-3.2,1.568h-.034V86.8h6.529V83.7H99.129V96.425h3.462v-.5c0-1.332.6-2.065,1.666-2.065,1.166,0,1.634.8,1.634,2.034v5.463c0,1.2-.435,2.031-1.6,2.031-1.3,0-1.764-.866-1.764-2.2V98.356H99.06v2.565c0,3.431,1.366,5.629,5.231,5.629,3.831,0,5.4-2.032,5.4-5.163V95.858c0-3.564-1.831-5-3.863-5",
    transform: "translate(-87.965 -74.325)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.575 42.381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.475,378.38h-13.92a.179.179,0,0,0-.177.178v4.625a.178.178,0,0,0,.177.178H371.1l-6.155,6.16a18.225,18.225,0,1,0-13.593,32.413v5.33h-5.488a.176.176,0,0,0-.179.176V432.4a.176.176,0,0,0,.179.177h5.488v5.236a.176.176,0,0,0,.177.177h4.955a.178.178,0,0,0,.179-.177v-5.241h5.488a.176.176,0,0,0,.176-.177v-4.958a.176.176,0,0,0-.176-.176H356.66v-5.417A18.215,18.215,0,0,0,368.6,393.37l6.068-6.072v5.177a.179.179,0,0,0,.18.177h4.625a.179.179,0,0,0,.18-.177V378.562a.179.179,0,0,0-.18-.178M353.7,417.276a13.421,13.421,0,1,1,13.421-13.421A13.42,13.42,0,0,1,353.7,417.276",
    transform: "translate(-335.47 -378.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.195,556.648H425.917a.17.17,0,0,0-.177.159v3.94a.168.168,0,0,0,.177.161h16.278a.169.169,0,0,0,.18-.161v-3.94a.171.171,0,0,0-.18-.159",
    transform: "translate(-415.629 -536.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.195,619.469H425.917a.173.173,0,0,0-.177.165v3.94a.168.168,0,0,0,.177.159h16.278a.169.169,0,0,0,.18-.159v-3.94a.174.174,0,0,0-.18-.165",
    transform: "translate(-415.629 -592.466)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal5);
export default __webpack_public_path__ + "static/media/goal-5.29836f74f5871a69f5e34337bd480d36.svg";
export { ForwardRef as ReactComponent };